import React from "react";
import "./GameInstructionsModal.scss";

/**
 * Game Instructions Modal Component
 * Displays game instructions in a popup modal
 */
function GameInstructionsModal({ isOpen, onClose, gameName, instructions }) {
  if (!isOpen) return null;

  return (
    <div className="game-instructions-modal-overlay" onClick={onClose}>
      <div className="game-instructions-modal" onClick={(e) => e.stopPropagation()}>
        <div className="instructions-modal-header">
          <h2>How to Play {gameName || "Game"}</h2>
          <button className="instructions-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="instructions-modal-content">
          {instructions ? (
            <p>{instructions}</p>
          ) : (
            <p>No instructions available for this game.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default GameInstructionsModal;







